module.exports = __webpack_public_path__ + "static/img/t22.cc47c4fd.png";